"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSearchEffects = void 0;
var _react = require("react");
var _searchContext = require("./search-context");
/**
 * Custom hook to handle search-related side effects
 * @param {Function} autocomplete - Autocomplete function
 * @param {Function} handleOnConfirm - Handle confirmation function
 * @returns {void}
 */
const useSearchEffects = (autocomplete, handleOnConfirm) => {
  const {
    autocompleteEndpoint,
    suggestedList,
    setSuggestedList,
    setIsLoading,
    searchValue,
    searchStringMinLength,
    domainSearchUrl,
    setDomainSearchUrl,
    abortMessage,
    appKeyHeader
  } = (0, _searchContext.useInternalSearch)();

  // Effect for getting initial suggestions
  (0, _react.useEffect)(() => {
    const abortController = new AbortController();
    const getInitialSuggestions = async () => {
      try {
        const sessionSuggestions = JSON.parse(sessionStorage.getItem('suggestedList'));
        // check if sessionSuggestions is an array of strings
        if (Array.isArray(sessionSuggestions) && sessionSuggestions.length > 0 && typeof sessionSuggestions[0] === 'string') {
          setSuggestedList(sessionSuggestions);
        }
      } catch (err) {
        setIsLoading(true);
      }
      if (suggestedList.length === 0) {
        try {
          const res = await fetch(autocompleteEndpoint, {
            method: 'GET',
            signal: abortController.signal,
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
              'X-App-Key': appKeyHeader
            }
          });
          const data = await res.json();
          setSuggestedList(data);
          sessionStorage.setItem('suggestedList', JSON.stringify(data));
        } catch (err) {
          if (err.name === 'AbortError') {
            // eslint-disable-next-line no-console
            console.error(err);
          }
        } finally {
          setIsLoading(false);
        }
      }
    };
    if (suggestedList.length === 0) {
      getInitialSuggestions();
    }
    return () => {
      abortController.abort(abortMessage);
    };
  }, [autocompleteEndpoint, suggestedList, setSuggestedList, setIsLoading, abortMessage]);

  // Effect for handling search value changes
  (0, _react.useEffect)(() => {
    const abortController = new AbortController();
    if (searchValue?.length >= searchStringMinLength) {
      autocomplete(searchValue, null, abortController);
      handleOnConfirm(searchValue, null, abortController);
    }
    // When search value changes, update domain search url with new search value
    if (domainSearchUrl) {
      const url = new URL(domainSearchUrl);
      url.searchParams.set('domainToCheck', searchValue);
      setDomainSearchUrl(url.href.toString());
    }
    return () => {
      abortController.abort(abortMessage);
    };
  }, [searchValue, autocomplete, domainSearchUrl, handleOnConfirm, searchStringMinLength, setDomainSearchUrl, abortMessage]);
};
exports.useSearchEffects = useSearchEffects;